import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { useHistory } from "react-router-dom";
import calender from "../../assets/images/Calendar3.svg";
import adddoc from "../../assets/images/Plus.svg";
import del from "../../assets/images/delete.svg";
import Header from "../../layouts/Header";
import "../../assets/styles/local/flag.css";
import "../../assets/styles/local/profile.css";
// import ReactFlagsSelect from "react-flags-select";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import moment from "moment";
import { Col, Modal } from "react-bootstrap";
import CurrencyInput from "react-currency-input";
import "react-datepicker/dist/react-datepicker.css";
import { BsChevronDown, BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { AiOutlinePlus } from "react-icons/ai";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { Switch } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import AppDatePicker from "../../components/Common/AppDatePicker";
import RouteLeavingGuard from "../../components/Common/RouteLeavingGuard";
import {
  AddDocToUser,
  AddJobtypes,
  DeleteJobtypes,
  FetchJobtypes,
  FetchRoleModuleAccess,
  FetchUserById,
  Fetchdocumentbyuserid,
  UpdateJobtypes,
  clearUpdateUser,
  deleteDoc,
  fetchLanguages,
  syncToQuickBooks,
  updateUser,
  FetchUserIntegration,
  fetchIdsType,
  fetchEmployeeType,
  fetchContractType,
  fetchCompanyCar,
  fetchReasons,
  FetchActiveUser,
  fetchUserCertification,
  insertDocToS3,
} from "../../redux/actions/action";
import {
  SelectNav,
  PersonalInfoForm,
  LegalInformationForm,
  BankAccountForm,
  CompanyCarForm,
  CertificationList,
  ProvidedItems,
  WageScreen,
  TimeOffScreen,
  CustomDropdown,
} from "../../utils/addMember/helpers";
import {
  informationNavItems,
  documentNavItems,
} from "../../utils/addMember/navItems";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import edit from "..//..//assets//icons/edit-2.svg";
import { API_URL } from "..//..//redux/constants/type";
import DocumentUploaderWithProgress from "../../components/Common/Document_Uploader_With_Progress";
import roundFileSize from "../../utils/Documents/roundFileSize";
import GoogleAuthButton from "../../components/Google/google-auth-button";
import { Button } from "@mui/material";

import { toast } from "react-toastify";
import LogoSmall from "../../assets/images/logo-small.png";
import floatingSound from "../../assets/audios/floating-notification-tone.wav";

import { OutlookAuthBtn } from "./OutlookAuthButton";
import { QuickbookSyncBtn } from "./QuickBookSyncButton";

const errorFields = {
  information: {
    name: "Please enter your name !",
    email: "Please enter your email !",
    password: "Please enter password.",
    phoneNumber: "Please enter your phone number",
    date: "Please enter date.",
    address: "Please enter address",
    zipCode: "Please enter ZIP-Code",
    language: "Please enter language",
  },
};
const errorBools = {
  name: false,
  email: false,
  password: false,
  phoneNumber: false,
  date: false,
  address: false,
  zipCode: false,
  language: false,
};

const StyledSwitch = styled(Switch)(({ theme }) => ({
  padding: 8,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    "&:before, &:after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
  },
}));

const Profilepage = () => {
  const roleAccess = window.localStorage.getItem("roleid");
  const packageID = window.localStorage.getItem("packageId");
  const companyid = window.localStorage.getItem("companyid");
  const fetchActiveUser = useSelector((state) => state.user.fetchActiveUser);
  const [roleOwnerDiseble, setRoleOwnerDiseble] = useState(false);
  const [roleManagerDiseble, setRoleManagerDiseble] = useState(false);
  const refNewStandardWageInput = useRef(null);
  const initialRender = React.useRef(true);
  let hiddenFileInput = useRef(null);
  const history = useHistory();
  const [information, setInfomation] = useState(true);
  const [wage, setWage] = useState(false);
  const [document, setDocument] = useState(false);
  const [timeOff, setTimeOff] = useState(false);
  const [FetchCompanyThemRes, setFetchCompanyThemRes] = useState([]);
  const [textcolor, setTextcolor] = useState("");
  const [searchlang, setSearchlang] = useState("");
  const [backgroundcolor, setBackgroundcolor] = useState("");
  const [newUser, setNewUser] = useState([]);
  const [errors, setErrors] = useState(errorBools);
  const [newdoc, setNewdoc] = useState([]);
  const [userData, setUserdata] = useState([]);
  const [fetchLanguageList, setFetchLanguageList] = useState([]);
  const [showStatusDrop, setShowStatusDrop] = useState(false);
  const [startDate, setStartDate] = useState();
  const [imageurl, setImageUrl] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [ziPcode, setZipcode] = useState("");
  const [taxnumber, setTaxnumber] = useState("");
  const [phonenumber, setPhonenumber] = useState("");
  const [securitynumber, setSecuritynumber] = useState("");
  const [language, setLanguage] = useState("");
  const [wagerate, setWagerate] = useState("");
  const [billrate, setBillrate] = useState("");
  const languages = window.localStorage.getItem("language");
  const [type, setType] = useState("");
  const [payment, setPayment] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [abbreviation, setAbbreviation] = useState("");
  const [isactive, setIsactive] = useState();
  const [jobpost, setJobpost] = useState("");
  const [weekHours, setWeekHours] = useState("");
  const [leaves, setLeaves] = useState([]);

  const [iscurrentcompany, setIscurrentcompany] = useState(
    "28830f30-b321-4662-a576-f23451677734",
  );
  const [isrequiretimesheetapproval, , setIsrequiretimesheetapproval] =
    useState("0");
  const [navErrors, setNavErrors] = useState({
    firstName: false,
    email: false,
    password: false,
    initials: false,
  });
  const [isallowmanualtime, setIsallowmanualtime] = useState("0");
  const [contracttype, setContracttype] = useState("");
  const [paymentperiod, setPaymentperiod] = useState("daily");
  const [jobid, setJobid] = useState("08dae7eb-6f27-4a95-88c2-d17738ddf900");
  const [roles, setRoles] = useState(process.env.REACT_APP_IS_MANAGER);
  const [roleid, setRoleid] = useState("");
  const [showTypeDrop, setShowTypeDrop] = useState(false);
  const [updateEmailNot, setUpdateEmailNot] = useState(false);
  const [showJobDrop, setShowJobDrop] = useState(false);
  const [select, setSelect] = useState("NL");
  const onSelect = (code) => setSelect(code);
  const [comp, setComp] = useState("");
  const [changeComp, setChangeComp] = useState("");
  const [popups, setPopups] = useState(false);
  const [rolename, setRolename] = useState("");
  const [imgurl, setImgurl] = useState("");
  const [docIProfile, setdocIProfile] = useState();
  const [fullName, setFullName] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedOption1, setSelectedOption1] = useState("");
  const [selectedOption2, setSelectedOption2] = useState("");
  const [selectedOption3, setSelectedOption3] = useState("");
  const [selectedOption4, setSelectedOption4] = useState("");
  const [activeSlider, setActiveSlider] = useState(false);
  const FetchCompanyDetails1 = useSelector(
    (state) => state.user.FetchCompanyDetails,
  );
  const [totalCertifications, setTotalCertifications] = useState([]);
  const dispatch = useDispatch();
  const certificationList = useSelector(
    (state) => state.user.fetchedCertification,
  );
  const newCreateUser = useSelector((state) => state.user.userCreate);
  const FetchUserData = useSelector((state) => state.user.FetchUserById);
  const Document = useSelector((state) => state.user.fetchDocument);
  const addfile = useSelector((state) => state.user.AddDocument);
  const FetchLanguagesData = useSelector(
    (state) => state.user.FetchlanguagesList,
  );
  const userid = window.localStorage.getItem("userid");
  const dltDoc = useSelector((state) => state.user.deleteDoc);
  const [newDate, setNewDate] = useState(new Date());
  const FetchActiveUserData = useSelector(
    (state) => state.user.fetchActiveUser?.data,
  );
  const [updatedon, setUpdateOn] = useState("");
  const [size, setSize] = useState([]);
  const options = [{ value: "English" }, { value: "Dutch" }];
  const userlastname = window.localStorage.getItem("lastname");
  const userfirstname = window.localStorage.getItem("firstname");
  const [fulLenghtDocProfile, setFulLenghtDocProfile] = useState(false);
  const [fetchTransEditProfile, setFetchTransEditProfile] = useState({});
  const t = (key) => fetchTransEditProfile?.[key] || "";
  const fetchTranslationDatas = useSelector(
    (state) => state.user.FetchTranslationList,
  );
  const [hoverJobList, setHoverJobList] = useState(false);
  const [indexJobtypeIndex, setIndexJobtypeIndex] = useState("");
  const [indexJobtype, setIndexJobtype] = useState();
  const [editJobValue, setEditJobValue] = useState("");
  const roleID = window.localStorage.getItem("roleid");
  const [oddLogId, setOddLogId] = useState("");
  const [evenLogId, setEvenLogId] = useState("");
  const [showPaymentDrop, setShowPaymentDrop] = useState(false);
  const roleModuleData = useSelector(
    (state) => state.user.FetchRoleModuleAccess,
  );
  const FetchJobtypesdata = useSelector((state) => state.user.FetchJobtypes);
  const UpdateJobtypesRes = useSelector((state) => state.user.UpdateJobtypes);
  const qbSyncStatus = useSelector((state) => state.user.qbSyncStatus);
  const qbSyncResp = useSelector((state) => state.user.qbSyncResponse);
  const [jobname, setJobname] = useState("");
  const [jobpostList, setJobpostList] = useState([]);
  const roleId = window.localStorage.getItem("roleid");
  const [authorisationRole, setAuthorisationRole] = useState("User");
  const [jobValue, setJobValue] = useState("");
  const [jobTypeEdit, setJobTypeEdit] = useState(false);
  const [updateDasswordDisable, setUpdateDasswordDisable] = useState(false);
  const [seewageRoleTabDisable, setSeewageRoleTabDisable] = useState(true);
  const [showContactDrop, setShowContactDrop] = useState(false);
  const AddJobtypesData = useSelector((state) => state.user.AddJobtypes);
  const updateUserRes = useSelector((state) => state.user.userUpdate);
  const [updateTaxNumberDisable, setUpdateTaxNumberDisable] = useState(false);
  const [securityNumberDisable, setSecurityNumberDisable] = useState(false);
  const [paginationObj, setPaginationObj] = useState({
    totalRecords: 0,
    currentPage: 0,
    startRecordIndex: 0,
    endRecordIndex: 0,
    totalPages: 0,
    records: [],
  });

  const [filelist, setFilelist] = useState([]);
  const [paymentaccount, setPaymentaccount] = useState("");
  const [description, setDescription] = useState("");
  const [oddWorkingHours, setOddWorkingHours] = useState(0);
  const [evenWorkingHours, setEvenWorkingHours] = useState(0);
  const [payroll, setPayRoll] = useState(false);
  const [timesheetapproval, setTimeSheetApproval] = useState(false);
  const [selectedInformationNav, setSelectedInformationNav] = useState(
    informationNavItems[0],
  );
  const [selectedDocumentNav, setSelectedDocumentNav] = useState(
    documentNavItems[0],
  );

  const { idsType, employeeType, contractType, companyCar, fetchedReasons } =
    useSelector((state) => state.user);

  const { insertedDoc } = useSelector((state) => state.user);
  const [personalForm, setPersonalForm] = useState({});

  const [legalForm, setLegalForm] = useState({});

  const [transportForm, setTransportForm] = useState({});
  const [bankAccounts, setBankAccounts] = useState([]);
  const [evenDays, setEvenDays] = useState({
    monday: "8",
    tuesday: "8",
    wednesday: "8",
    thursday: "8",
    friday: "8",
    saturday: "0",
    sunday: "0",
  });
  const [oddDays, setOddDays] = useState({
    monday: "8",
    tuesday: "8",
    wednesday: "8",
    thursday: "8",
    friday: "8",
    saturday: "0",
    sunday: "0",
  });
  const [providedItems, setProvidedItems] = useState([]);

  const [certificationsList, setCertificationsList] = useState([]);
  const [timeOffEntries, setTimeOffEntries] = useState([]);
  const [applyToAllYear, setApplyToAllYear] = useState(false);

  const calculatePagination = (pageNumber) => {
    let records = newdoc || [];
    let tempPaginationObj = {
      totalRecords: records.filter((rec) => rec?.type === selectedDocumentNav)
        .length,
      currentPage: pageNumber,
      startRecordIndex: Math.max(10 * pageNumber - 9, 1),
      endRecordIndex: Math.min(
        10 * pageNumber,
        records.filter((rec) => rec?.type === selectedDocumentNav).length,
      ),
      totalPages: Math.ceil(
        records.filter((rec) => rec?.type === selectedDocumentNav).length / 10,
      ),
      records: records
        .filter((rec) => rec?.type === selectedDocumentNav)
        ?.slice((pageNumber - 1) * 10, pageNumber * 10),
    };
    setPaginationObj({ ...tempPaginationObj });
  };

  useEffect(() => {
    calculatePagination(1);
  }, [newdoc, selectedDocumentNav]);

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleOptionChange1 = (event) => {
    setSelectedOption1(event.target.value);
  };
  const handleOptionChange2 = (event) => {
    setSelectedOption2(event.target.value);
  };
  const handleOptionChange3 = (event) => {
    setSelectedOption3(event.target.value);
  };
  const handleOptionChange4 = (event) => {
    setSelectedOption4(event.target.value);
  };
  const [profilePhoto, setProfilePhoto] = useState(null);
  const handleClick = (event) => {
    event.preventDefault();
    hiddenFileInput.current.click();
  };
  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      fontWeight: 400,
      color: "#333333",
      fontSize: "14px",
      background: "#F1F1F1 0% 0% no-repeat padding-box",
      boxShadow: "0px 3px 6px #00000029",
      opacity: 1,
    },
  }));
  useEffect(() => {
    fetchScreenTranslations("Profile").then((res) => {
      setFetchTransEditProfile(res);
    });
    dispatch(FetchRoleModuleAccess(roleID));
    dispatch(FetchJobtypes());
  }, []);

  const profileUpload = async (file) => {
    var formData = new FormData();
    formData.append("", file);
    try {
      const response = await axios.put(
        `${API_URL}/api/Files/UploadToS3`,
        formData,
        {
          headers: {
            "Content-Type": " multipart/form-data",
          },
        },
      );
      setImageUrl(response.data[0]);
    } catch (error) {}
  };

  const deleteImage = () => {
    setImageUrl("");
  };
  const [totaldoc, setTotaldoc] = useState();
  const onFileUploaded = (data) => {
    setNewdoc((prev) => [
      ...prev,
      {
        documentname: data[0].name,
        documentextension: data[0].type,
        documentcontent: "string",
        link: data[0].link,
        documentsize: data[0].size,
        ispossibledelete: 1,
        islocked: 0,
        type: selectedDocumentNav,
      },
    ]);
    dispatch(
      AddDocToUser(userid, userid, [
        {
          documentname: data[0].name,
          documentextension: data[0].type,
          documentcontent: "string",
          link: data[0].link,
          documentsize: data[0].size,
          ispossibledelete: 1,
          islocked: 0,
          type: selectedDocumentNav,
        },
      ]),
    );
  };

  useEffect(() => {
    if (addfile != null) {
      if (addfile.status == true) {
        dispatch(Fetchdocumentbyuserid(userid));
      }
    }
  }, [addfile]);

  useEffect(() => {
    if (dltDoc != null) {
      if (dltDoc.status == true) {
        dispatch(Fetchdocumentbyuserid(userid));
      } else {
      }
    }
  }, [dltDoc]);

  const handelCancels = () => {
    // if (comp !== changeComp) {
    //   setPopups(true);
    // } else {
    history.goBack();
    // }
  };

  useEffect(() => {
    dispatch(Fetchdocumentbyuserid(userid));
    dispatch(fetchLanguages());
    dispatch(fetchIdsType());
    dispatch(fetchEmployeeType());
    dispatch(fetchContractType());
    dispatch(fetchCompanyCar());
    dispatch(fetchReasons());
    dispatch(FetchActiveUser(companyid));
    dispatch(fetchUserCertification());
  }, []);

  useEffect(() => {
    if (!initialRender.current) {
      if (Document != null) {
        if (Document.status == true) {
          setNewdoc(Document?.data);
          setTotaldoc(Document?.data?.length);
        } else {
        }
      }
    } else {
      initialRender.current = false;
    }
  }, [Document]);

  useEffect(() => {
    dispatch(FetchUserById(userid));
  }, []);

  ////////////////////FETCH UESERID  API ////////////
  useEffect(() => {
    if (!initialRender.current) {
      if (FetchUserData != null) {
        if (FetchUserData.status == true) {
          setUserdata(FetchUserData.data);
          setImageUrl(FetchUserData.data[0]?.imageurl);

          setTaxnumber(FetchUserData.data[0]?.taxnumber);
          setSecuritynumber(FetchUserData.data[0]?.securitynumber);

          setWagerate(FetchUserData.data[0]?.wagerate);
          setBillrate(FetchUserData.data[0]?.billrate);
          setType(FetchUserData.data[0]?.type);
          setPaymentperiod(FetchUserData.data[0]?.paymentperiod);
          setJobid(FetchUserData.data[0]?.jobid);
          setJobname(FetchUserData.data[0]?.jobtypename);
          setRoleid(FetchUserData.data[0]?.roledetails[0]?.roleid);
          setRolename(FetchUserData.data[0]?.roledetails[0]?.rolename);
          setContracttype(FetchUserData.data[0]?.contracttype);
          setUpdateOn(FetchUserData.data[0]?.updatedon);
          setPaymentaccount(FetchUserData?.data[0]?.paymentaccount);
          setDescription(FetchUserData?.data[0]?.description);
          setActiveSlider(FetchUserData.data[0]?.isactive === 1 ? true : false);
          const userData = FetchUserData?.data[0];
          setPersonalForm({
            firstname: userData.firstname || "",
            email: userData.email || "",
            initials: userData.initials || "",
            title: userData.title || "",
            password: userData.password,
            userid: userData.userid || "",
            address: userData.address || "",
            businessTelephone: userData.businessTelephone || "",
            personalTelephone: userData.personalTelephone || "",
            dateofbirth: userData.dateofbirth
              ? new Date(userData.dateofbirth)
              : "",
            birthPlace: userData.birthPlace || "",
            personalEmail: userData.personalEmail || "",
            countryofBirth: userData.countryofBirth || "",
            nationality: userData.nationality || "",
            emergencyContact: userData.emergencyContact || "",
            gender: userData.gender || "",
            maritalStatus: userData.maritalStatus || "",
            emergencyTelephone: userData.emergencyTelephone || "",
            relation: userData.relation || "",
            language: userData.language || "",
          });

          const legalData = { ...userData?.userlegal?.[0] };
          if (legalData["pensionExpectedDate"]) {
            legalData["pensionExpectedDate"] = new Date(
              legalData["pensionExpectedDate"],
            );
          }
          if (legalData["contractStartDate"]) {
            legalData["contractStartDate"] = new Date(
              legalData["contractStartDate"],
            );
          }
          if (legalData["contactEndDate"]) {
            legalData["contactEndDate"] = new Date(legalData["contactEndDate"]);
          }
          if (legalData["trialPeriodend"]) {
            legalData["trialPeriodend"] = new Date(legalData["trialPeriodend"]);
          }
          if (legalData["validity"]) {
            legalData["validity"] = new Date(legalData["validity"]);
          }
          setLegalForm(legalData);
          setBankAccounts(userData?.userfinancial);
          if (userData?.userbenefits && userData?.userbenefits?.[0]) {
            const tranportFormData = userData?.userbenefits?.[0];
            tranportFormData["leasingStartDate"] = tranportFormData[
              "leasingStartDate"
            ]
              ? new Date(tranportFormData["leasingStartDate"])
              : "";
            setTransportForm(tranportFormData);
          }

          setProvidedItems(
            userData?.userprovideditems &&
              userData?.userprovideditems.length > 0
              ? userData?.userprovideditems.map((item) => {
                  return {
                    ...item,
                    dateProvided: new Date(item["dateProvided"]),
                  };
                })
              : [],
          );
          if (userData?.userlogtimer && userData?.userlogtimer?.length > 0) {
            for (let key of userData?.userlogtimer) {
              if (key?.type === "even") {
                const obj = { ...key };
                delete obj.type;
                delete obj.weekNumber;
                setEvenLogId(obj.userLogTimerid);
                delete obj.userLogTimerid;
                setEvenDays(obj);
              } else {
                const obj = { ...key };
                delete obj.type;
                delete obj.weekNumber;
                setOddLogId(obj.userLogTimerid);
                delete obj.userLogTimerid;
                setOddDays(obj);
              }
            }
          }
          setTimeOffEntries(userData?.usertimeoff);
          const updatedLeaveData = FetchUserData?.data[0]?.usertimeoff?.map(
            (entry) => ({
              ...entry,
              from: entry.from
                ? moment.utc(entry.from).format("DD.MM.YYYY")
                : "",
              to: entry.to ? moment.utc(entry.to).format("DD.MM.YYYY") : "",
            }),
          );
          setTotalCertifications(userData?.usercertification);
          setTimeSheetApproval(userData?.timesheetapproval == 0 ? false : true);
          setPayRoll(userData?.payroll == 0 ? false : true);
          setApplyToAllYear(userData?.applyToAllYear == 0 ? false : true);
          setLeaves(updatedLeaveData);
          setIsactive(FetchUserData.data[0]?.isactive === 1 ? true : false);
        } else {
        }
      }
    } else {
      initialRender.current = false;
    }
  }, [FetchUserData]);

  ///////////////// THEME API ///////////////////
  React.useEffect(() => {
    if (!initialRender.current) {
      if (FetchCompanyDetails1 != null) {
        if (FetchCompanyDetails1.status == true) {
          setFetchCompanyThemRes(FetchCompanyDetails1.data);
          setTextcolor(FetchCompanyDetails1.data[0]?.textcolor);
          setBackgroundcolor(FetchCompanyDetails1.data[0]?.backgroundcolor);
        } else {
        }
      }
    } else {
      initialRender.current = false;
    }
  }, [FetchCompanyDetails1]);

  useEffect(() => {
    if (FetchLanguagesData?.data?.status == true) {
      setFetchLanguageList(FetchLanguagesData?.data?.data);
    }
  }, [FetchLanguagesData]);

  useEffect(() => {
    if (!initialRender.current) {
      if (newCreateUser != null) {
        if (newCreateUser.status == true) {
          setNewUser(newCreateUser.data);
        } else {
        }
      }
    } else {
      initialRender.current = false;
    }
  }, [newCreateUser]);

  /////////////////////UPADTE API DISPATCH ///////////

  const convertDatesToISO = () => {
    const updatedData = leaves?.map((entry) => ({
      ...entry,
      from: entry.from
        ? moment.utc(entry.from, "DD.MM.YYYY").format("YYYY-MM-DD")
        : "",
      to: entry.to
        ? moment.utc(entry.to, "DD.MM.YYYY").format("YYYY-MM-DD")
        : "",
    }));
    return updatedData;
  };
  const handleChange = () => {
    setChangeComp("");
    // const updateErrors = { ...errors };
    // if (fullName === "") {
    //   updateErrors.name = true;
    // }
    // if (email === "") {
    //   updateErrors.email = true;
    // }

    // if (password2 === "") {
    //   updateErrors.password = true;
    // }

    // if (
    //   Object.keys(errors).some(
    //     (singleError) => updateErrors[singleError] === true
    //   )
    // ) {
    //   setErrors(updateErrors);
    //   setInfomation(true);
    //   setWage(false);
    //   setDocument(false);
    //   setTimeOff(false);
    //   return;
    // }
    // if (emailError) {
    //   setInfomation(true);
    //   setWage(false);
    //   setDocument(false);
    //   setTimeOff(false);
    //   return;
    // }

    // if (fullName !== "" && email !== "" && password2 !== "") {
    //   setErrors({ ...errorBools });
    const fnames = fullName.split(" ");
    const firstName = fnames[0];
    fnames.shift();
    const lastName = fnames.join(" ") || "";
    // window.localStorage.setItem("firstname", firstName);
    // window.localStorage.setItem("lastname", lastName);
    window.localStorage.setItem("userimageurl", imageurl);
    window.localStorage.setItem("abbreviation", abbreviation);
    window.localStorage.setItem("jobpost", jobname);
    const leaveData = convertDatesToISO();
    dispatch(
      updateUser({
        isactive: activeSlider ? 1 : 0,
        userid,
        ...personalForm,
        actionTakerUserId: userid,
        lastname: "",
        userlegal: Object.keys(legalForm).length > 0 ? [legalForm] : [],
        userprovideditems: providedItems,
        userbenefits:
          Object.keys(transportForm).length > 0 ? [transportForm] : [],
        usercertification: totalCertifications,
        usertimeoff: timeOffEntries,
        userfinancial: bankAccounts,
        applyToAllYear: applyToAllYear === true ? 1 : 0,
        oddWorkingHours,
        evenWorkingHours,
        timesheetapproval: timesheetapproval === true ? 1 : 0,
        payroll: payroll === true ? 1 : 0,
        // leaveData,
        isverified: 0,
        isrequiretimesheetapproval: 0,
        isallowmanualtime: 0,
        isdeleted: 0,
        iscurrentcompany,
        isrequiretimesheetapproval,
        isallowmanualtime,
        imageurl,
        billrate,
        contracttype,
        paymentperiod,
        type,
        wagerate,
        jobid: jobid ?? "",
        roleid,
        userlogtimer: [
          {
            userLogTimerid: evenLogId,
            type: "even",
            weekNumber: moment().week(),
            ...evenDays,
          },
          {
            userLogTimerid: oddLogId,
            type: "odd",
            weekNumber: moment().week(),
            ...oddDays,
          },
        ],
      }),
    );

    // history.goBack();
    // }
  };

  const renderError = (error) => {
    return (
      <p
        style={{
          color: "red",
          margin: 0,
          fontSize: "11px",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-end",
          justifyContent: "center",
          marginTop: "-1rem",
        }}
      >
        {error}
      </p>
    );
  };

  function convertToDots(password) {
    let passwordDots = "";
    for (let i = 0; i < password.length; i++) {
      passwordDots += ".";
    }
    return passwordDots;
  }

  function handlePasswordChange(event) {
    setPassword2(event.target.value);
  }

  useEffect(() => {
    setPassword(convertToDots(password));
  }, [password]);

  const refTypeDropDownContainer = useRef();
  const refTypeDropDownContainerExclude = useRef();
  const handleMouseDowTypeDD = (event) => {
    if (
      refTypeDropDownContainer.current &&
      !refTypeDropDownContainer.current.contains(event.target) &&
      !refTypeDropDownContainerExclude.current.contains(event.target)
    ) {
      setShowStatusDrop(false);
    }
  };
  useEffect(() => {
    if (showStatusDrop) {
      window.addEventListener("mousedown", handleMouseDowTypeDD);
    } else {
      window.addEventListener("mousedown", handleMouseDowTypeDD);
    }
    return () => {
      window.removeEventListener("mousedown", handleMouseDowTypeDD);
    };
  }, [showStatusDrop]);
  useEffect(() => {
    const sum = Object.values(evenDays).reduce((acc, curr) => {
      if (!isNaN(parseInt(curr))) acc = acc + parseInt(curr);
      else acc += 0;
      return acc;
    }, 0);
    setEvenWorkingHours(sum);
  }, [evenDays]);

  useEffect(() => {
    const sum = Object.values(oddDays).reduce((acc, curr) => {
      if (!isNaN(parseInt(curr))) acc = acc + parseInt(curr);
      else acc += 0;
      return acc;
    }, 0);
    setOddWorkingHours(sum);
  }, [oddDays]);

  useEffect(() => {
    if (updateUserRes?.status === true) {
      dispatch(clearUpdateUser());
      localStorage.setItem("firstname", updateUserRes.data?.firstname);
      localStorage.setItem("lastname", updateUserRes.data?.lastname);
      localStorage.setItem("initials", updateUserRes.data?.initials);
      localStorage.setItem("language", updateUserRes.data?.language);

      window.location.reload();
    }
  }, [updateUserRes]);
  //////ROLE ACCESS//////////////////////////////
  React.useEffect(() => {
    if (roleModuleData?.status === 200) {
      for (let i = 0; i < roleModuleData?.data?.data?.length; i++) {
        if (
          roleModuleData?.data?.data[i]?.moduleid ===
            "08da4e8a-6050-40db-8d54-5751dc976028" &&
          roleModuleData?.data?.data[i]?.accesslevelsid ===
            "08da33e9-5a64-4f8c-8d88-49e4982df312" &&
          roleModuleData?.data?.data[i]?.featureid ===
            "08da3f0d-0371-4dd3-8c86-e51222d60007"
        ) {
          setUpdateEmailNot(true);
        } else if (
          roleModuleData?.data?.data[i]?.moduleid ===
            "08da4e8a-6050-40db-8d54-5751dc976028" &&
          roleModuleData?.data?.data[i]?.accesslevelsid ===
            "08da33e9-5a64-4f8c-8d88-49e4982df312" &&
          roleModuleData?.data?.data[i]?.featureid ===
            "08da3f0d-0371-4dd3-8c86-e51222d60008"
        ) {
          setUpdateDasswordDisable(true);
        } else if (
          roleModuleData?.data?.data[i]?.moduleid ===
            "08da4e8a-6050-40db-8d54-5751dc976028" &&
          roleModuleData?.data?.data[i]?.accesslevelsid ===
            "08da33e9-5a64-4f8c-8d88-49e4982df310" &&
          roleModuleData?.data?.data[i]?.featureid ===
            "08da3f0d-0371-4dd3-8c86-e51222d60010"
        ) {
          setUpdateTaxNumberDisable(true);
        } else if (
          roleModuleData?.data?.data[i]?.moduleid ===
            "08da4e8a-6050-40db-8d54-5751dc976028" &&
          roleModuleData?.data?.data[i]?.accesslevelsid ===
            "08da33e9-5a64-4f8c-8d88-49e4982df310" &&
          roleModuleData?.data?.data[i]?.featureid ===
            "08da3f0d-0371-4dd3-8c86-e51222d60012"
        ) {
          setSecurityNumberDisable(true);
        } else if (
          roleModuleData?.data?.data[i]?.moduleid ===
            "08da4e8a-6050-40db-8d54-5751dc976028" &&
          roleModuleData?.data?.data[i]?.accesslevelsid ===
            "08da33e9-5a64-4f8c-8d88-49e4982df312" &&
          roleModuleData?.data?.data[i]?.featureid ===
            "08da3f0d-0371-4dd3-8c86-e51222d60016"
        ) {
          setSeewageRoleTabDisable(false);
        }
      }
    } else {
    }
  }, [roleModuleData]);
  const refType2DropDownContainer = useRef();
  const refType2DropDownContainerExclude = useRef();
  const handleMouseDowTypeDD2 = (event) => {
    if (
      refType2DropDownContainer.current &&
      !refType2DropDownContainer.current.contains(event.target) &&
      !refType2DropDownContainerExclude.current.contains(event.target)
    ) {
      setShowTypeDrop(false);
    }
  };
  useEffect(() => {
    if (showTypeDrop) {
      window.addEventListener("mousedown", handleMouseDowTypeDD2);
    } else {
      window.addEventListener("mousedown", handleMouseDowTypeDD2);
    }
    return () => {
      window.removeEventListener("mousedown", handleMouseDowTypeDD2);
    };
  }, [showTypeDrop]);
  const typeoptions = [
    { value: "Hourly" },
    { value: "Daily" },
    { value: "Fixed" },
  ];
  const pymentoptions = [
    { value: "Daily" },
    { value: "Weekly" },
    { value: "Monthly" },
  ];
  const refPaymentTypeDropDownContainer = useRef();
  const refPaymentTypeDropDownContainerExclude = useRef();
  const handleMouseDowPaymentDD = (event) => {
    if (
      refPaymentTypeDropDownContainer.current &&
      !refPaymentTypeDropDownContainer.current.contains(event.target) &&
      !refPaymentTypeDropDownContainerExclude.current.contains(event.target)
    ) {
      setShowPaymentDrop(false);
    }
  };
  useEffect(() => {
    if (showPaymentDrop) {
      window.addEventListener("mousedown", handleMouseDowPaymentDD);
    } else {
      window.addEventListener("mousedown", handleMouseDowPaymentDD);
    }
    return () => {
      window.removeEventListener("mousedown", handleMouseDowPaymentDD);
    };
  }, [showPaymentDrop]);
  useEffect(() => {
    if (FetchJobtypesdata != null) {
      if (FetchJobtypesdata?.data?.status === true) {
        setJobpostList(FetchJobtypesdata?.data?.data);
      } else {
      }
    }
  }, [FetchJobtypesdata]);
  useEffect(() => {
    if (AddJobtypesData != null) {
      if (AddJobtypesData?.status === true) {
        setJobid(AddJobtypesData?.data?.jobtypeid);
        dispatch(FetchJobtypes());
        setShowJobDrop(false);
        setJobValue("");
      } else {
      }
    }
  }, [AddJobtypesData]);
  useEffect(() => {
    if (UpdateJobtypesRes != null) {
      if (UpdateJobtypesRes?.status === true) {
        dispatch(FetchJobtypes());
      } else {
      }
    }
  }, [UpdateJobtypesRes]);

  const refJobTypeDropDownContainer = useRef();
  const refJobTypeDropDownContainerExclude = useRef();
  const handleMouseDownJobDD = (event) => {
    if (
      refJobTypeDropDownContainer.current &&
      !refJobTypeDropDownContainer.current.contains(event.target) &&
      !refJobTypeDropDownContainerExclude.current.contains(event.target)
    ) {
      setShowJobDrop(false);
    }
  };

  useEffect(() => {
    if (showJobDrop) {
      window.addEventListener("mousedown", handleMouseDownJobDD);
    } else {
      window.addEventListener("mousedown", handleMouseDownJobDD);
    }
    return () => {
      window.removeEventListener("mousedown", handleMouseDownJobDD);
    };
  }, [showJobDrop]);

  // const contactTypeoptions = [ { value: "Contract" }, { value: "Freelancer" } ];

  const contactTypeoptions = [
    { value: t("Contract") },
    { value: t("Freelancer") },
  ];

  const refContactTypeDropDownContainer = useRef();
  const refContactTypeDropDownContainerExclude = useRef();
  const handleMouseDownContactDD = (event) => {
    if (
      refContactTypeDropDownContainer.current &&
      !refContactTypeDropDownContainer.current.contains(event.target) &&
      !refContactTypeDropDownContainerExclude.current.contains(event.target)
    ) {
      setShowContactDrop(false);
    }
  };
  useEffect(() => {
    if (showContactDrop) {
      window.addEventListener("mousedown", handleMouseDownContactDD);
    } else {
      window.addEventListener("mousedown", handleMouseDownContactDD);
    }
    return () => {
      window.removeEventListener("mousedown", handleMouseDownContactDD);
    };
  }, [showContactDrop]);
  const pdfdownload = (documentid, documentname) => {
    axios({
      method: "post",
      url: `${API_URL}/api/Files/DownloadToS3?documentid=` + documentid,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
      // data: {
      //   message?.message
      // },
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      // var el = document.createElement('div');
      const document = window.document || {};
      const link = document.createElement("a");
      link.href = url;
      link.download = documentname;
      document.body.appendChild(link);
      link.click();
      // link.setAttribute("download", `FinalDocument.pdf`);
      // Append to html link element page
      // document.body.appendChild(link);
      // Start download
      // link.click();
      // Clean up and remove the link
      // link.parentNode.removeChild(link);
      // return docFileDownload;
      // }, 1000)
    });
  };

  const [jobHover, setJobHover] = useState(false);

  const handleJobName = () => {
    if (jobname && jobname !== "") {
      if (jobname.length <= 20) {
        return jobname;
      } else if (jobname.length > 20 && showJobDrop) {
        return "..." + jobname.slice(-20);
      } else if (jobname.length > 20 && !showJobDrop) {
        return jobname.slice(0, 20) + "...";
      }
      return "Select";
    } else {
      return "Select";
    }
  };
  const [dateError, setDateError] = useState(false);

  const handleTabChange = (tab) => {
    const obj = {
      firstName: false,
      email: false,
      password: false,
      initials: false,
    };
    const checkErrors = () => {
      if (!personalForm.firstname) obj.firstName = true;
      if (!personalForm.email) obj.email = true;
      if (!personalForm.initials) obj.initials = true;
      if (!personalForm.password) obj.password = true;
      if (Object.keys(obj).some((item) => obj[item] === true))
        setNavErrors(obj);
    };
    checkErrors();
    if (tab === "information") {
      setInfomation(true);
      setWage(false);
      setDocument(false);
      setTimeOff(false);
    } else if (
      tab === "wagenrole" &&
      !Object.keys(obj).some((item) => obj[item] === true)
    ) {
      setInfomation(false);
      setWage(true);
      setDocument(false);
      setTimeOff(false);
    } else if (
      tab === "document" &&
      !Object.keys(obj).some((item) => obj[item] === true)
    ) {
      checkErrors();
      setInfomation(false);
      setWage(false);
      setDocument(true);
      setTimeOff(false);
    } else if (
      tab === "timeoff" &&
      !Object.keys(obj).some((item) => obj[item] === true)
    ) {
      checkErrors();
      setInfomation(false);
      setWage(false);
      setDocument(false);
      setTimeOff(true);
    }
    // }
  };

  const [syncToQuickBook, setSyncToQuickBook] = useState(false);

  const syncQuickBooksClick = () => {
    setSyncToQuickBook(true);
    dispatch(syncToQuickBooks());
  };

  useEffect(() => {
    if (qbSyncResp && Object.keys(qbSyncResp).length > 0 && syncToQuickBook) {
      QuickBookNotification(qbSyncResp);
      setSyncToQuickBook(false);
    }
  }, [qbSyncResp]);

  const [showQBSync, setShowQBSync] = useState(false);

  const fetchIntergrationRes = useSelector(
    (state) => state.user.fetchIntergrationRes,
  );

  useEffect(() => {
    dispatch(FetchUserIntegration());
  }, []);

  useEffect(() => {
    if (fetchIntergrationRes.status === true) {
      let integrationList = fetchIntergrationRes.data;
      if (
        integrationList &&
        integrationList.length &&
        integrationList.length > 0
      ) {
        let qbAvailable = integrationList.filter(
          (o) =>
            o.integrationId === "08dcbbb8-80a8-44c9-86ae-e713ad987001" &&
            o.integrationStatus === "Active",
        );

        if (qbAvailable.length > 0) {
          setShowQBSync(true);
        } else {
          setShowQBSync(false);
        }
      }
    }
  }, [fetchIntergrationRes]);

  const ascTakingDatafromChild = (asc) => {
    setChangeComp(asc);
  };

  return (
    <>
      <Header />
      <div className="mx-2">
        <div className="container-fluid ">
          {/* <div className="row mx-xl-3 mx-lg-5 mx-xxl-4 mx-md-2 mx-sm-1 px-xxl-4 px-lg- px-xl-3 px-md-2 px-sm-2"> */}
          <div className="row">
            <div className="col-12 mb-2">
              <div className="d-flex align-items-center justify-content-between">
                <div className="profile_coWorker">Co-Workers</div>
                <div className="d-flex align-items-center gap-2 hideGoogleAuthbtn">
                  {/* <Button variant="contained" onClick={syncQuickBooksClick} disabled={qbSyncStatus == "INPROGRESS"}>
                    {qbSyncStatus == "INPROGRESS" ? 'Syncing' : 'Sync to QuickBooks'}
                  </Button> */}
                  {showQBSync && (
                    <QuickbookSyncBtn
                      syncAction={syncQuickBooksClick}
                      disabled={qbSyncStatus == "INPROGRESS"}
                      syncLabel={
                        qbSyncStatus == "INPROGRESS"
                          ? "Syncing to..."
                          : "Sync to"
                      }
                    />
                  )}
                  {/* {packageID === process.env.REACT_APP_IS_PREMIUM && (
                    <div className="hideGoogleAuthbtn">
                      <GoogleAuthButton />
                    </div>
                  )}
                  <OutlookAuthBtn /> */}
                </div>
              </div>
            </div>
            <RouteLeavingGuard
              when={changeComp !== ""}
              navigate={(path) => history.push(path)}
              shouldBlockNavigation={(location) => {
                // This case it blocks the navigation when:
                // 1. the login form is dirty, and
                // 2. the user is going to 'sign-up' scene.
                //    (Just an example, in real case you might
                //     need to block all location regarding this case)

                if (changeComp !== "") {
                  if (!["/profile", "/planboard"].includes(location.pathname)) {
                    // if (location.pathname === "/profile" && !canGoBack) {
                    //   return true;
                    // } else if (location.pathname === "/profile" && canGoBack)
                    //   return false;
                    return true;
                  }
                }
                return false;
              }}
            />
            {/* ///////////////////// RIGHT SIDE //////////////// */}
            <div className="col-xl-4 col-lg-12 col-md-12 col-sm-12 col-12 col-xxl-3 pb-4 ">
              <div
                className="profile_columnfirst me-3"
                style={{ backgroundColor: `${backgroundcolor}` }}
              >
                <div className="py-5 ">
                  <h4
                    className="headingprofile"
                    style={{
                      color: `${textcolor}`,
                      wordBreak: "break-all",
                      fontWeight: "800",
                    }}
                  >
                    {t("Profile")}
                  </h4>
                </div>

                <div className="d-flex justify-content-center pt-4 mt-xxl-4 ">
                  <input
                    type="file"
                    accept="image/*"
                    style={{ display: "none" }}
                    ref={hiddenFileInput}
                    onChange={(event) => {
                      const fileUploaded = event.target.files[0];
                      if (fileUploaded) {
                        const image = URL.createObjectURL(fileUploaded);
                        setProfilePhoto(image);
                        profileUpload(fileUploaded);
                      } else {
                        return;
                      }
                    }}
                  />

                  {imageurl ? (
                    <div className="profile-image1 ">
                      <img
                        style={{
                          width: "100%",
                          height: "100%",
                          borderRadius: "100%",
                          objectFit: "cover",
                        }}
                        src={imageurl}
                        alt=""
                      />
                    </div>
                  ) : personalForm.initials ? (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div
                        className="add-profile-image"
                        style={{
                          border: `1px #00256E dashed`,
                          borderRadius: "50%",
                          backgroundColor: "#94a6c7",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          color: "white",
                        }}
                      >
                        {personalForm.initials ? personalForm.initials : ""}
                      </div>
                      <div className="d-flex justify-content-center pt-3 ">
                        <h6
                          className="mt-2"
                          style={{
                            fontSize: "12px",
                            cursor: "pointer",
                            color: "#A5A5A5",
                            wordBreak: "break-all",
                          }}
                          onClick={handleClick}
                        >
                          {t("Change")}
                        </h6>
                        <img
                          className="mx-2"
                          style={{ cursor: "pointer" }}
                          src={del}
                          alt="delete"
                          onClick={() => setImageUrl("")}
                        />
                      </div>
                    </div>
                  ) : (
                    <div
                      className="profile-image1"
                      style={{
                        border: `1px #00256E dashed`,
                        height: "15vw",
                        width: "15vw",
                        borderRadius: "50%",
                      }}
                    >
                      <div style={{ marginTop: "40%", cursor: "pointer" }}>
                        <AiOutlinePlus
                          style={{
                            fontSize: "1.5rem",
                            fontWeight: "bold",
                            color: "#00246A",
                          }}
                          className="responsive-check"
                          onClick={handleClick}
                        />
                        <br />
                        <p
                          className="company"
                          onClick={handleClick}
                          style={{ wordBreak: "break-all" }}
                        >
                          {t("Add a photo")}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
                <div style={{ height: "50px" }}>
                  {imageurl && (
                    <div className="d-flex justify-content-center pt-3 gap-2 ">
                      <h6
                        className="mt-2"
                        style={{
                          fontSize: "12px",
                          cursor: "pointer",
                          color: "#A5A5A5",
                          wordBreak: "break-all",
                        }}
                        onClick={handleClick}
                      >
                        {t("Change")}
                      </h6>
                      <img
                        className="mx"
                        style={{ cursor: "pointer", color: "#A5A5A5" }}
                        src={del}
                        alt="delete"
                        onClick={deleteImage}
                      />
                    </div>
                  )}
                </div>
                <div className="pt-xxl-5 mt-xxl-3 mt-xl-2 mt-lg-2 mt-sm-2 ">
                  <input
                    className="noborder2 text-center"
                    disabled
                    type="text"
                    placeholder="Name"
                    style={{
                      color: "#333333",
                      fontSize: "18px",
                      fontWeight: "bold",
                      opacity: 0.5,
                    }}
                    // onChange={(e, value) => {
                    //   setFullName(e.target.value);
                    //   setChangeComp(e.target.value);
                    // }}
                    value={personalForm?.firstname}
                  />
                  {/* <h3 style={{ color: `${textcolor}`, fontSize: "18px", fontWeight: "700" }}> {`${firstname}` + " " + `${lastname}`}</h3> */}
                </div>
                <div className="pt-xxl-5 pt-lg-5 pt-sm-5 pt-xl-4">
                  <input
                    className=""
                    style={{
                      border: "none",
                      textAlign: "center",
                      color: `${textcolor}`,
                      fontSize: "clamp(18px, 1.318vw, 1.25vw)",
                      fontWeight: "700",
                    }}
                    value={fullName}
                    onChange={(e, value) => {
                      setFullName(
                        e.target.value.charAt(0).toUpperCase() +
                          e.target.value.slice(1),
                      );
                    }}
                  />
                </div>
              </div>
            </div>
            {/* ////////////////////// LEFT SIDE //////////////// */}
            <div
              className={
                showStatusDrop
                  ? "col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12 col-xxl-9 leftscreen drop-spaces"
                  : "col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12 col-xxl-9 mb-4 leftscreen "
              }
              style={{
                backgroundColor: `${backgroundcolor}`,
                // minHeight: "646.63px",
                borderRadius: "8px",
              }}
            >
              <div className="row " style={{ backgroundColor: "#0000000D" }}>
                <div className="col p-0">
                  <div
                    className={
                      information
                        ? "tagcolor information pt-5 pe-"
                        : "pro_information pt-5 pe-"
                    }
                    onClick={() => handleTabChange("information")}
                    style={{ wordBreak: "break-all" }}
                  >
                    {t("Information")}
                    <hr
                      className={information ? "horizontalpro" : "horizontal1"}
                    />
                  </div>
                </div>
                <div className="col p-0">
                  <div
                    className={wage ? "tagcolor wage pt-5" : "pro_wage pt-5"}
                    onClick={() => handleTabChange("wagenrole")}
                    style={{ wordBreak: "break-all" }}
                  >
                    {t("Wage and role")}
                    <hr
                      className={wage ? "horizontalWage" : "horizontal1"}
                      style={{ color: "#333333" }}
                    />
                  </div>
                </div>

                <div className="col p-0">
                  <div className="">
                    <div
                      className={
                        document
                          ? "tagcolor documents pt-5"
                          : "pro_documents pt-5"
                      }
                      onClick={() => handleTabChange("document")}
                      style={{ wordBreak: "break-all" }}
                    >
                      {t("Documents")}
                      <hr
                        className={document ? "horizontalWage" : "horizontal1"}
                      />
                    </div>
                  </div>
                </div>
                {packageID === process.env.REACT_APP_IS_PREMIUM && (
                  <div className="col p-0 hideGoogleAuthbtn">
                    <div className="">
                      <div
                        className={
                          timeOff
                            ? "tagcolor documents pt-5"
                            : "pro_documents pt-5 hideGoogleAuthbtn"
                        }
                        onClick={() => handleTabChange("timeoff")}
                        style={{ wordBreak: "break-all" }}
                      >
                        {/* {fetchTransEditProfile[52]?.translation} */}
                        Time OFF
                        <hr
                          className={timeOff ? "horizontalWage" : "horizontal1"}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* ///////// INFORMATION TAB ///////// */}

              {information && (
                <div>
                  <div className="px-4 mx-2 pt-5">
                    <SelectNav
                      items={informationNavItems}
                      setSelectedItem={setSelectedInformationNav}
                      selectedItem={selectedInformationNav}
                      setErrors={setNavErrors}
                      personalForm={personalForm}
                    >
                      {selectedInformationNav === "Personal" ||
                      selectedInformationNav === "Persoonlijk" ? (
                        <PersonalInfoForm
                          personalForm={personalForm}
                          setPersonalForm={setPersonalForm}
                          FetchLanguagesData={FetchLanguagesData}
                          errors={navErrors}
                          setErrors={setNavErrors}
                          updateScreen={true}
                          ascTakingDatafromChild={ascTakingDatafromChild}
                        />
                      ) : selectedInformationNav === "Legal" ||
                        selectedInformationNav === "Juridisch" ? (
                        <LegalInformationForm
                          legalForm={legalForm}
                          setLegalForm={setLegalForm}
                          idsType={idsType}
                          employeeType={employeeType}
                          contractType={contractType}
                          FetchJobtypesdata={FetchJobtypesdata}
                        />
                      ) : selectedInformationNav === "Financial" ||
                        selectedInformationNav === "Financieel" ? (
                        <BankAccountForm
                          bankAccounts={bankAccounts}
                          setBankAccounts={setBankAccounts}
                        />
                      ) : selectedInformationNav === "Benefits" ||
                        selectedInformationNav === "Voordelen" ? (
                        <CompanyCarForm
                          transportForm={transportForm}
                          setTransportForm={setTransportForm}
                          fetchedReasons={fetchedReasons}
                          companyCar={companyCar}
                        />
                      ) : selectedInformationNav === "Certification" ||
                        selectedInformationNav === "Certificering" ? (
                        <CertificationList
                          certificationList={certificationList}
                          setCertificationsList={setCertificationsList}
                          totalCertifications={totalCertifications}
                          setTotalCertifications={setTotalCertifications}
                          insertedDoc={insertedDoc}
                        />
                      ) : selectedInformationNav === "Provided Items" ||
                        selectedInformationNav === "Geleverde artikelen" ? (
                        <ProvidedItems
                          providedItems={providedItems}
                          setProvidedItems={setProvidedItems}
                        />
                      ) : (
                        ""
                      )}
                    </SelectNav>
                    <div className="d-flex justify-content-between gap-2 flex-wrap mt-xxl-4 mt-xl- mt-lg-1">
                      <div className="align-items-end mt-xxl-5 mt-xl-1 mt-lg-1 hideGoogleAuthbtn">
                        <p
                          className="mb-0 pt-2 "
                          style={{
                            color: "#333333",
                            fontSize: "10px",
                            wordBreak: "break-all",
                          }}
                        >
                          {t("History")}
                        </p>
                        <div className="d-flex">
                          <p
                            style={{
                              color: "#a5a5a5",
                              fontSize: "10px",
                              wordBreak: "break-all",
                            }}
                          >
                            {t("Last Change")}:
                          </p>
                          <p
                            className="ms-2"
                            style={{ color: "#a5a5a5", fontSize: "10px" }}
                          >
                            {moment(updatedon).format("DD.MM.YYYY")}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex justify-content-end mt-xxl-5 mt-xl-1 mt-lg-1 gap-4 pe-lg-3 pe-xxl-4 addcancelbttn">
                        <button className="canclebtn" onClick={handelCancels}>
                          {t("Cancel ")}
                        </button>
                        <button
                          className="invitebtn me-"
                          onClick={handleChange}
                          style={{ wordBreak: "break-all" }}
                          disabled={
                            personalForm.firstname &&
                            personalForm.email &&
                            personalForm.initials &&
                            personalForm.password
                              ? false
                              : true
                          }
                        >
                          {t("Change")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* /////// WAGE AND ROLE TAB ////////////// */}

              {wage && (
                <div className="" style={{ backgroundColor: "white" }}>
                  <div className="pt-3 mt-2  px-3">
                    <div
                      className="justify-content-between text-align-start wage-role-table-flex"
                      style={{
                        display: "grid",
                        gridTemplateColumns:
                          "repeat(auto-fit, minmax(0px, 1fr))",
                        gap: "20px",
                      }}
                    >
                      <div
                        className="row mobileView1"
                        style={{
                          width: "100%",
                        }}
                      >
                        <div className="col-6 col-md-4 col-lg-6">
                          <p className="wage-common-font">
                            {t("Wage Rate")}
                          </p>
                          <hr className="mb-2" />
                          <div className="common-font">
                            <CurrencyInput
                              className="noborder2"
                              placeholder="€ 0,00"
                              value={wagerate}
                              ref={refNewStandardWageInput}
                              onChangeEvent={(
                                event,
                                maskedvalue,
                                floatvalue,
                              ) => {
                                setWagerate(floatvalue);
                                setChangeComp(event.target.value);
                              }}
                              style={{
                                color: "#333333",
                                // width: "150px",
                                fontSize: "clamp(14px, 1.025vw, 0.833vw)",
                                fontWeight: "bold",
                              }}
                              decimalSeparator=","
                              thousandSeparator="."
                              precision="2"
                              allowEmpty={true}
                              prefix="€ "
                            />
                          </div>
                        </div>

                        <div className="col-6 col-md-4 col-lg-6">
                          <p
                            className="wage-common-font"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            {t("Payment Period")}
                          </p>
                          <hr className="mb-2" />
                          <div className="common-font">
                            <div
                              style={{
                                cursor: "pointer",
                                position: "relative",
                                display: "flex",
                                flexDirection: "row",
                                // marginTop:"5px"
                              }}
                            >
                              <div
                                ref={refPaymentTypeDropDownContainerExclude}
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                                onClick={() =>
                                  setShowPaymentDrop(!showPaymentDrop)
                                }
                              >
                                <p
                                  className="margin-0"
                                  style={{
                                    fontSize: "clamp(14px, 1.025vw, 0.833vw)",
                                    fontWeight: "bold",
                                    color: "#333333",
                                    flexGrow: "1",
                                    textTransform: "capitalize",
                                  }}
                                >
                                  {paymentperiod ? paymentperiod : t("No")}
                                </p>
                                <BsChevronDown
                                  size={10}
                                  style={{
                                    marginTop: "5px",
                                    flexGlow: "1",
                                    color: "#333333",
                                  }}
                                  className={`${
                                    showPaymentDrop
                                      ? "down-arrow down-arrow-rotate bi-paperclip me-4"
                                      : "down-arrow bi-paperclip me-4"
                                  }`}
                                />
                              </div>
                              {showPaymentDrop && (
                                <div
                                  className="drop-down-pyment"
                                  id="lang-drop-down"
                                  ref={refPaymentTypeDropDownContainer}
                                >
                                  {pymentoptions?.map((item, i) => {
                                    return (
                                      <div
                                        className={
                                          item?.value === paymentperiod
                                            ? " typ-list-select typ-list"
                                            : "typ-list"
                                        }
                                        // className=''
                                      >
                                        <p
                                          key={i}
                                          className="margin-0 ms-3 pb-1"
                                          style={{
                                            opacity: 1,
                                            fontSize:
                                              "clamp(14px, 1.025vw, 0.833vw)",
                                            fontWeight: 400,
                                            color: "#333333",
                                          }}
                                          onClick={() => {
                                            // setStatusId(item.id);
                                            setPaymentperiod(item.value);
                                            setShowPaymentDrop(false);
                                            setChangeComp(item.value);
                                          }}
                                        >
                                          {item.value}
                                        </p>
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        className="row mobileView1"
                        style={{
                          width: "100%",
                        }}
                      >
                        <div className="col-6 col-md-4 col-lg-6">
                          <p className="wage-common-font">
                            {t("Bill Rate")}
                          </p>
                          <hr className="mb-2" />
                          <div className="common-font">
                            <CurrencyInput
                              className="noborder2"
                              placeholder="€ 0,00"
                              value={billrate}
                              ref={refNewStandardWageInput}
                              onChangeEvent={(
                                event,
                                maskedvalue,
                                floatvalue,
                              ) => {
                                setBillrate(floatvalue);
                                setChangeComp(event.target.value);
                              }}
                              style={{
                                color: "#333333",
                                fontSize: "clamp(14px, 1.025vw, 0.833vw)",
                                fontWeight: "bold",
                              }}
                              decimalSeparator=","
                              thousandSeparator="."
                              precision="2"
                              allowEmpty={true}
                              prefix="€ "
                            />
                          </div>
                        </div>

                        <div className="col-6 col-md-4 col-lg-6">
                          <p className="wage-common-font">
                            {t("Type")}
                          </p>
                          <hr className="mb-2" />
                          <div className="common-font">
                            <div
                              style={{
                                cursor: "pointer",
                                position: "relative",
                                display: "flex",
                                flexDirection: "row",
                                // width: "60px",
                              }}
                            >
                              <div
                                onClick={() => setShowTypeDrop(!showTypeDrop)}
                                ref={refTypeDropDownContainerExclude}
                                style={{
                                  width: "100%",
                                  display: "flex",
                                  justifyContent: "space-between",
                                }}
                              >
                                <p
                                  className="margin-0 "
                                  style={{
                                    // marginLeft: "3px",
                                    fontSize: "clamp(14px, 1.025vw, 0.833vw)",
                                    fontWeight: "bold",
                                    color: "#333333",
                                    flexGrow: "1",
                                    textTransform: "capitalize",
                                  }}
                                >
                                  {type ? type : t("No")}
                                </p>
                                <BsChevronDown
                                  size={10}
                                  style={{
                                    marginTop: "5px",
                                    flexGlow: "1",
                                    color: "#333333",
                                  }}
                                  className={`${
                                    showTypeDrop
                                      ? "down-arrow down-arrow-rotate bi-paperclip me-4"
                                      : "down-arrow bi-paperclip me-4"
                                  }`}
                                />
                              </div>
                              {showTypeDrop && (
                                <div
                                  className="drop-down-pyment"
                                  id="lang-drop-down"
                                  ref={refTypeDropDownContainer}
                                >
                                  {typeoptions?.map((item, i) => {
                                    return (
                                      <div
                                        className={
                                          item.value === type
                                            ? " typ-list-select typ-list"
                                            : "typ-list"
                                        }
                                        // className=''
                                      >
                                        <p
                                          key={i}
                                          className="margin-0 ms-3 pb-1"
                                          style={{
                                            opacity: 1,
                                            fontSize:
                                              "clamp(14px, 1.025vw, 0.833vw)",
                                            color: "#333333",
                                            fontWeight: 400,
                                            margin: "0px 0px 0px 16px",
                                          }}
                                          onClick={() => {
                                            // setStatusId(item.id);
                                            setType(item.value);
                                            setShowTypeDrop(false);
                                            setChangeComp(item.value);
                                          }}
                                        >
                                          {item.value}
                                        </p>
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        className="row mobileView1"
                        style={{
                          width: "100%",
                        }}
                      >
                        <div className="col-6 col-md-4 col-lg-6">
                          <p className="wage-common-font">
                            {/* {fetchTransEditProfile[22]?.translation} */}
                            Payroll
                          </p>
                          <hr className="mb-2" />

                          <input
                            type="checkbox"
                            // checked={item.checked}
                            className="form-check-input pointer companyRadio ms-"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginLeft: "1rem",
                            }}
                            value={payroll}
                            checked={payroll}
                            onChange={() => {
                              setPayRoll((prev) => !prev);
                            }}
                          />
                        </div>

                        <div className="col-6 col-md-4 col-lg-6">
                          <p
                            className="wage-common-font"
                            style={{ whiteSpace: "nowrap" }}
                          >
                            {/* {fetchTransEditProfile[23]?.translation} */}
                            Timesheet approval
                          </p>
                          <hr className="mb-2" />
                          <input
                            type="checkbox"
                            // checked={item.checked}
                            className="form-check-input pointer companyRadio ms-"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginLeft: "1rem",
                            }}
                            value={timesheetapproval}
                            checked={timesheetapproval}
                            onChange={() => {
                              setTimeSheetApproval((prev) => !prev);
                            }}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="my-xxl-5 py-4 hidefor-Mobile">
                      <div
                        style={{
                          backgroundColor: "#e4edfa",
                          display: "flex",
                          flexWrap: "wrap",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "10px",
                          borderRadius: "10px",
                          fontSize: 13,
                          width: "100%",
                          maxWidth: "100%",
                          overflow: "auto",
                        }}
                      >
                        <div
                          className="py-2"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            fontWeight: 500,
                            width: "40%",
                            gap: "10px",
                          }}
                        >
                          <div>
                            Working Time
                            <span
                              style={{ fontWeight: 300, marginLeft: "10px" }}
                            >
                              Total Even week
                            </span>
                          </div>
                          <div>{evenWorkingHours}</div>
                        </div>
                        <div
                          className="py-2"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            fontWeight: 500,
                            width: "40%",
                            gap: "10px",
                          }}
                        >
                          <div>Total Odd week</div>
                          <div>{oddWorkingHours}</div>
                        </div>
                        <div
                          className="py-2"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: "40px",
                            fontWeight: 300,
                            fontSize: 12,
                          }}
                        >
                          Apply to all year
                          <input
                            type="checkbox"
                            checked={applyToAllYear}
                            className="form-check-input pointer companyRadio ms-"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginLeft: "1rem",
                            }}
                            onChange={(e) => {
                              setApplyToAllYear((prev) => !prev);
                            }}
                          />
                        </div>
                      </div>
                      <div
                        style={{
                          // backgroundColor: "#e4edfa",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "10px",
                          fontSize: 13,
                          width: "100%",
                          color: "37f857d",
                          maxWidth: "100%",
                          overflow: "auto",
                        }}
                      >
                        <span
                          style={{
                            margin: 0,
                            marginRight: "10px",
                            fontSize: 12,
                            width: "100%",
                          }}
                        >
                          {" "}
                          Even Week
                        </span>
                        {Object.keys(evenDays).map((day, index) => {
                          let finalDay = day.slice(0, 3).split("");
                          finalDay = `${finalDay[0].toUpperCase()}${finalDay
                            .join("")
                            .slice(1, 3)}`;
                          return (
                            <div
                              index={index}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                width: "100%",
                              }}
                            >
                              <div>{finalDay}</div>
                              <input
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  backgroundColor:
                                    evenDays[day] != 0 ? "#e4edfa" : "white",
                                  color: "#333333",
                                  padding: "10px 30px",
                                  borderRadius: "10px",
                                  border: "1px dashed #e8e8e8",
                                  width: "5.5rem",
                                  fontWeight: 500,
                                }}
                                value={evenDays[day]}
                                onChange={(e) => {
                                  if (
                                    (!isNaN(parseInt(e.target.value)) &&
                                      parseInt(e.target.value) <= 8) ||
                                    e.target.value === ""
                                  ) {
                                    const existing = { ...evenDays };
                                    const day = Object.keys(existing)[index];
                                    existing[day] = e.target.value;
                                    setEvenDays(existing);
                                  }
                                }}
                              />
                            </div>
                          );
                        })}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "10px",
                          fontSize: 13,
                          width: "100%",
                          color: "37f857d",
                          maxWidth: "100%",
                          overflow: "auto",
                        }}
                      >
                        <span
                          style={{
                            margin: 0,
                            marginRight: "10px",
                            fontSize: 12,
                            width: "100%",
                          }}
                        >
                          {" "}
                          Odd Week
                        </span>
                        {Object.keys(oddDays).map((day, index) => {
                          return (
                            <div
                              index={index}
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                width: "100%",
                              }}
                            >
                              {/* <div>{day}</div> */}
                              <input
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  backgroundColor:
                                    oddDays[day] != 0 ? "#e4edfa" : "white",
                                  color: "#333333",
                                  padding: "10px 30px",
                                  borderRadius: "10px",
                                  border: "1px dashed #e8e8e8",
                                  width: "5.5rem",
                                  fontWeight: 500,
                                }}
                                value={oddDays[day]}
                                onChange={(e) => {
                                  if (
                                    (!isNaN(parseInt(e.target.value)) &&
                                      parseInt(e.target.value) <= 8) ||
                                    e.target.value === ""
                                  ) {
                                    const existing = { ...oddDays };
                                    const day = Object.keys(existing)[index];
                                    existing[day] = e.target.value;
                                    setOddDays(existing);
                                  }
                                }}
                              />
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    <div className="mt-5 pt-xxl-4 pt-xl-5 pt-lg-5 pb-5">
                      <div className="text-start">
                        <p className="wage-common-font ms-2 mt-4">
                          {t("Change")}
                        </p>
                      </div>
                      <div className="row" aria-disabled>
                        <div className="col-8">
                          <div
                            className="row roles-options roles-options-onmobile"
                            style={{ marginLeft: "0px" }}
                          >
                            <Col className="p-0" style={{ height: "100%" }}>
                              <p
                                style={
                                  roleid === process.env.REACT_APP_IS_OWNER
                                    ? { backgroundColor: `#00246A` }
                                    : { backgroundColor: `` }
                                }
                                className={
                                  roleid === process.env.REACT_APP_IS_OWNER
                                    ? "role-single-add authorisation-roles active-role active-role-response"
                                    : roleAccess ===
                                        process.env.REACT_APP_IS_MANAGER
                                      ? "pointerEvent role-single-add wage-authorisation-roles"
                                      : "role-single-add wage-authorisation-roles "
                                }
                                onClick={() => {
                                  if (roleOwnerDiseble) {
                                    setAuthorisationRole("Owner");
                                    setRoleid(
                                      "08da3f0d-0371-4dd3-8c86-e51222d56188",
                                    );
                                    setChangeComp(
                                      process.env.REACT_APP_IS_OWNER,
                                    );
                                  }
                                }}
                              >
                                {t("Owner")}
                              </p>
                            </Col>
                            <Col style={{ height: "100%" }}>
                              <p
                                style={
                                  roleid ===
                                  "08da3f0d-0371-4dd3-8c86-e51222d56199"
                                    ? { backgroundColor: `#00246A` }
                                    : { backgroundColor: `` }
                                }
                                className={
                                  roleid === process.env.REACT_APP_IS_MANAGER
                                    ? "role-single-add wage-authorisation-roles active-role active-role-response"
                                    : "role-single-add wage-authorisation-roles "
                                }
                                onClick={() => {
                                  if (roleManagerDiseble || roleOwnerDiseble) {
                                    setAuthorisationRole("Manager");
                                    setRoleid(
                                      "08da3f0d-0371-4dd3-8c86-e51222d56190",
                                    );
                                    setChangeComp(
                                      "08da3f0d-0371-4dd3-8c86-e51222d56190",
                                    );
                                  }
                                }}
                              >
                                {/* {fetchTransEditProfile[33]?.translation} */}
                                Manager
                              </p>
                            </Col>
                            <Col style={{ height: "100%" }}>
                              <p
                                style={
                                  roleid === process.env.REACT_APP_IS_USER
                                    ? { backgroundColor: `#00246A` }
                                    : { backgroundColor: `` }
                                }
                                className={
                                  roleid === process.env.REACT_APP_IS_USER
                                    ? "role-single-add wage-authorisation-roles active-role active-role-response"
                                    : "role-single-add wage-authorisation-roles "
                                }
                                onClick={() => {
                                  if (roleManagerDiseble || roleOwnerDiseble) {
                                    setAuthorisationRole("User");
                                    setRoleid(
                                      "08da3f0d-0371-4dd3-8c86-e51222d56189",
                                    );
                                    setChangeComp(
                                      "08da3f0d-0371-4dd3-8c86-e51222d56189",
                                    );
                                  }
                                }}
                              >
                                {t("User")}
                              </p>
                            </Col>
                            <Col className="p-0" style={{ height: "100%" }}>
                              <p
                                style={
                                  roleid === process.env.REACT_APP_IS_VIEWER
                                    ? { backgroundColor: "#00246A" }
                                    : { backgroundColor: `` }
                                }
                                className={
                                  roleid === process.env.REACT_APP_IS_VIEWER
                                    ? "role-single-add wage-authorisation-roles active-role active-role-response"
                                    : "role-single-add wage-authorisation-roles "
                                }
                                onClick={() => {
                                  if (roleManagerDiseble || roleOwnerDiseble) {
                                    setAuthorisationRole("Freelancer");
                                    setRoleid(
                                      "08da3f0d-0371-4dd3-8c86-e51222d56191",
                                    );
                                    setChangeComp(
                                      process.env.REACT_APP_IS_VIEWER,
                                    );
                                  }
                                }}
                              >
                                {t("Viewer")}
                              </p>
                            </Col>
                          </div>
                        </div>
                        <div className="col-4 ">
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                              marginLeft: 10,
                              marginTop: 5,
                            }}
                          >
                            <div
                              style={{
                                color: "rgba(51, 51, 51, 1)",
                                fontSize: 11,
                              }}
                            >
                              Active?
                            </div>
                            <StyledSwitch
                              className="profiletoggle"
                              onChange={() => setActiveSlider((prev) => !prev)}
                              checked={activeSlider}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex justify-content-between gap-2 flex-wrap mt-xxl-4 mt-xl- mt-lg-1">
                    <div className="align-items-end mt-xxl-5 mt-xl-1 mt-lg-1 hideGoogleAuthbtn">
                      <p
                        className="mb-0 pt-2 "
                        style={{
                          color: "#333333",
                          fontSize: "10px",
                          wordBreak: "break-all",
                        }}
                      >
                        {t("History")}
                      </p>
                      <div className="d-flex">
                        <p
                          style={{
                            color: "#a5a5a5",
                            fontSize: "10px",
                            wordBreak: "break-all",
                          }}
                        >
                          {t("Last Change")}:
                        </p>
                        <p
                          className="ms-2"
                          style={{ color: "#a5a5a5", fontSize: "10px" }}
                        >
                          {moment(updatedon).format("DD.MM.YYYY")}
                        </p>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end mt-xxl-5 mt-xl-1 mt-lg-1 gap-4 pe-lg-3 pe-xxl-4 addcancelbttn">
                      <button className="canclebtn" onClick={handelCancels}>
                        {t("Cancel ")}
                      </button>
                      <button
                        className="invitebtn me-"
                        onClick={handleChange}
                        style={{ wordBreak: "break-all" }}
                        disabled={
                          personalForm.firstname &&
                          personalForm.email &&
                          personalForm.initials &&
                          personalForm.password
                            ? false
                            : true
                        }
                      >
                        {t("Change")}
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/*///////// DOCUMENT TAB /////////////////// */}

              {document && (
                <div className=" m-4 mt-3  ">
                  <SelectNav
                    items={documentNavItems}
                    setSelectedItem={setSelectedDocumentNav}
                    selectedItem={selectedDocumentNav}
                    setErrors={setNavErrors}
                    screen="documents"
                  >
                    <div style={{ width: "100%" }}>
                      <div
                        className="table-doc-info"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <div className="d-flex pt-1">
                          <DocumentUploaderWithProgress
                            onUploaded={onFileUploaded}
                            maxSizeInMb={100}
                          >
                            <label
                              className="mx"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                              }}
                            >
                              <img
                                src={adddoc}
                                alt="addicons"
                                className="mb-3 pro_doc"
                              />
                              <p
                                className="mx-2 ft"
                                style={{ wordBreak: "break-all" }}
                              >
                                {t("Add Doc")}
                              </p>
                            </label>
                          </DocumentUploaderWithProgress>
                        </div>
                        <div className="custom-pagination">
                          <div className="range-text">
                            {`${paginationObj.startRecordIndex} - ${paginationObj.endRecordIndex} of ${paginationObj.totalRecords}`}
                          </div>
                          <div className="pagination-buttons">
                            <div
                              className={`pagination-button ${
                                paginationObj.currentPage === 1
                                  ? "disabled"
                                  : ""
                              }`}
                              onClick={() =>
                                calculatePagination(
                                  paginationObj.currentPage - 1,
                                )
                              }
                            >
                              <BsChevronLeft />
                            </div>
                            <div className="pagination-current-page">
                              {paginationObj.currentPage}
                            </div>
                            <div
                              className={`pagination-button ${
                                paginationObj.totalPages === 0 ||
                                paginationObj.totalPages ===
                                  paginationObj.currentPage
                                  ? "disabled"
                                  : ""
                              }`}
                              onClick={() =>
                                calculatePagination(
                                  paginationObj.currentPage + 1,
                                )
                              }
                            >
                              <BsChevronRight />
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div
                          className="col-5 ft"
                          style={{
                            textAlign: "initial",
                            wordBreak: "break-all",
                          }}
                        >
                          {t("Name")}
                        </div>
                        <div
                          className="col-2 ft hideGoogleAuthbtn"
                          style={{ wordBreak: "break-all" }}
                        >
                          {" "}
                          {t("Size")}e
                        </div>
                        <div
                          className="col-2 ft hideGoogleAuthbtn"
                          style={{ wordBreak: "break-all" }}
                        >
                          {t("Date")}
                        </div>
                        <div
                          className="col-2 ft hideGoogleAuthbtn text-align-end"
                          style={{ wordBreak: "break-all" }}
                        >
                          {t("Sender")}
                        </div>
                        <div className="col-1 ft text-align-end"></div>
                      </div>
                      <hr className="mb-2" style={{ color: "grey" }} />
                      <div
                        className=""
                        style={{
                          overflowX: "hidden",
                          overflowY: "auto",
                          height: "290px",
                        }}
                      >
                        {paginationObj.records.map((item, i) => {
                          return (
                            <>
                              <div className="row py-1">
                                <div className="d-flex">
                                  <div>{/* <img src={docImage} /> */}</div>

                                  <div
                                    className="col-9 col-md-5 col-sm-6 ps-1 ft"
                                    style={{
                                      textAlign: "initial",
                                      // color: "#A5A5A580",
                                      color: "#A5A5A580",
                                    }}
                                  >
                                    <LightTooltip
                                      disableHoverListener={
                                        item.documentname?.length > 30
                                          ? false
                                          : true
                                      }
                                      title={item.documentname}
                                      placement="top-start"
                                    >
                                      <div
                                        style={{ width: "16vw" }}
                                        // className="pro_truncated"
                                        className={
                                          roleId ===
                                            process.env.REACT_APP_IS_USER &&
                                          item.ispossibledelete === 1
                                            ? "pro_truncated pointer"
                                            : roleId ===
                                                  process.env
                                                    .REACT_APP_IS_VIEWER &&
                                                item.ispossibledelete === 1
                                              ? "pro_truncated pointer"
                                              : roleId ===
                                                  process.env.REACT_APP_IS_OWNER
                                                ? "pro_truncated pointer"
                                                : roleId ===
                                                    process.env
                                                      .REACT_APP_IS_MANAGER
                                                  ? "pro_truncated pointer"
                                                  : "pro_truncated"
                                        }
                                        onClick={() => {
                                          if (
                                            roleId ===
                                              process.env.REACT_APP_IS_USER &&
                                            item.ispossibledelete === 1
                                          ) {
                                            pdfdownload(
                                              item?.documentid,
                                              item?.documentname,
                                            );
                                          } else if (
                                            roleId ===
                                              process.env.REACT_APP_IS_VIEWER &&
                                            item.ispossibledelete === 1
                                          ) {
                                            pdfdownload(
                                              item?.documentid,
                                              item?.documentname,
                                            );
                                          } else if (
                                            roleId ===
                                              process.env
                                                .REACT_APP_IS_MANAGER ||
                                            roleId ===
                                              process.env.REACT_APP_IS_OWNER
                                          ) {
                                            pdfdownload(
                                              item?.documentid,
                                              item?.documentname,
                                            );
                                          }
                                          // roleId === process.env.REACT_APP_IS_USER && item.ispossibledelete === 1 ? pdfdownload(
                                          //   item?.link,
                                          //   item?.documentname
                                          // ):roleId === process.env.REACT_APP_IS_VIEWER && item.ispossibledelete === 1 ? pdfdownload(
                                          //   item?.link,
                                          //   item?.documentname
                                          // ):roleId === process.env.REACT_APP_IS_MANAGER || roleId === process.env.REACT_APP_IS_OWNER ? pdfdownload(
                                          //   item?.link,
                                          //   item?.documentname
                                          // ):null
                                        }}
                                      >
                                        {item.documentname}
                                      </div>
                                    </LightTooltip>
                                  </div>
                                  <div className="col-2 pro_ft hideGoogleAuthbtn">
                                    {roundFileSize(item?.documentsize, 2)}
                                  </div>
                                  <div className="col-2 ps-2 pro_ft hideGoogleAuthbtn">
                                    {moment(item.date).format("DD.MM.YYYY")}
                                  </div>

                                  <div className="col-2 ft hideGoogleAuthbtn">
                                    <div className="d-flex justify-content-end me-2">
                                      {item?.uploadedby ? (
                                        <div className="ps-2">
                                          <img
                                            className="ms-3 ms-xxl-5"
                                            style={{
                                              width: "20px",
                                              height: "20px",
                                              borderRadius: "50%",
                                            }}
                                            src={item?.uploadedby}
                                            alt=""
                                          />
                                        </div>
                                      ) : (
                                        <div
                                          className=""
                                          style={{
                                            width: " 1.458vw",
                                            height: "1.458vw",
                                            minWidth: "20px",
                                            minHeight: "20px",
                                            borderRadius: "50%",
                                            objectFit: "cover",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: "#FFFFFF",
                                            fontsize:
                                              "clamp(14px, 0.833vw, 0.833vw)",
                                            fontWeight: 400,
                                            background: "#95A7C6",
                                          }}
                                        >
                                          {userlastname[0]?.toUpperCase()
                                            ? userfirstname[0]?.toUpperCase() +
                                              "" +
                                              userlastname[0]?.toUpperCase()
                                            : userfirstname
                                                .slice(0, 2)
                                                .toUpperCase()}
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                  <div
                                    className="col-1 dlt-icon-mobile"
                                    style={{ color: "#A5A5A580" }}
                                  >
                                    {item.ispossibledelete === 1 ? (
                                      <div className="">
                                        <img
                                          className="ms-1 mb-2"
                                          style={{
                                            cursor: "pointer",
                                            width: "17px",
                                            height: "18px",
                                            color: "#A5A5A580",
                                          }}
                                          src={del}
                                          alt=" "
                                          onClick={() => {
                                            dispatch(
                                              deleteDoc(item.documentid),
                                            );
                                          }}
                                        />
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                            </>
                          );
                        })}
                      </div>

                      <div className="  "></div>
                    </div>
                  </SelectNav>
                  {/* <div className="d-flex justify-content-between mt-5">
                    <div className="align-items-end pt-xxl-5 pt-xl-3  pt-lg-3 pt-sm-3 "> */}
                  <div className="d-flex justify-content-between gap-2 flex-wrap mt-xxl-4 mt-xl- mt-lg-1">
                    <div className="align-items-end mt-xxl-5 mt-xl-1 mt-lg-1 hideGoogleAuthbtn">
                      <p
                        className="mb-0 pt-2"
                        style={{
                          color: "#333333",
                          fontSize: "clamp(10px, 0.732vw, 0.885vw)",
                          wordBreak: "break-all",
                        }}
                      >
                        {t("History")}
                      </p>
                      <div className="d-flex">
                        <p
                          style={{
                            color: "#a5a5a5",
                            fontSize: "clamp(10px, 0.732vw, 0.885vw)",
                            wordBreak: "break-all",
                          }}
                        >
                          {t("Last Change")}:
                        </p>
                        <p
                          className="ms-2"
                          style={{
                            color: "#a5a5a5",
                            fontSize: "clamp(10px, 0.732vw, 0.885vw)",
                          }}
                        >
                          {" "}
                          {moment(updatedon).format("DD.MM.YYYY")}
                        </p>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end  gap-4 pb-3 pt-xxl-5 pt-xl-3 pt-lg-3 pt-sm-3 addcancelbttn">
                      <button
                        className="canclebtn"
                        onClick={handelCancels}
                        style={{ wordBreak: "break-all" }}
                      >
                        {t("Cancel ")}
                      </button>
                      <button
                        className="invitebtn"
                        onClick={handleChange}
                        style={{ wordBreak: "break-all" }}
                      >
                        {t("Change")}
                      </button>
                    </div>
                  </div>
                </div>
              )}
              {timeOff && (
                <>
                  <TimeOffScreen
                    timeOffEntries={timeOffEntries}
                    setTimeOffEntries={setTimeOffEntries}
                    FetchUserData={FetchUserData}
                  />
                  <div className="d-flex justify-content-between gap-2 flex-wrap mt-xxl-4 mt-xl- mt-lg-1">
                    <div className="align-items-end mt-xxl-5 mt-xl-1 mt-lg-1 hideGoogleAuthbtn">
                      <p
                        className="mb-0 pt-2 "
                        style={{
                          color: "#333333",
                          fontSize: "10px",
                          wordBreak: "break-all",
                        }}
                      >
                        {t("History")}
                      </p>
                      <div className="d-flex">
                        <p
                          style={{
                            color: "#a5a5a5",
                            fontSize: "10px",
                            wordBreak: "break-all",
                          }}
                        >
                          {t("Last Change")}:
                        </p>
                        <p
                          className="ms-2"
                          style={{ color: "#a5a5a5", fontSize: "10px" }}
                        >
                          {moment(updatedon).format("DD.MM.YYYY")}
                        </p>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end mt-xxl-5 mt-xl-1 mt-lg-1 gap-4 pe-lg-3 pe-xxl-4 addcancelbttn">
                      <button className="canclebtn" onClick={handelCancels}>
                        {t("Cancel ")}
                      </button>
                      <button
                        className="invitebtn me-"
                        onClick={handleChange}
                        style={{ wordBreak: "break-all" }}
                        disabled={
                          personalForm.firstname &&
                          personalForm.email &&
                          personalForm.initials &&
                          personalForm.password
                            ? false
                            : true
                        }
                      >
                        {t("Change")}
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {popups && (
        <Modal
          centered
          id="profilePopup"
          show={popups}
          className="modelwidth13"
          style={{
            backgroundColor: "transparent",
            opacity: 0.9,
          }}
        >
          <Modal.Body>
            <div className="flex_class my-5">
              <div className=" " style={{ color: "#FC685A", fontSize: "14px" }}>
                {/* The changes made will not be save. */}
                {t("The changes made will not be save")}
              </div>

              <div
                className=" mt-3"
                style={{ color: "#333333", fontSize: "14px" }}
              >
                {/* Do you want to proceed? */}
                {t("Do you want to proceed?")}
              </div>

              <div className="mt-5 pt-5">
                <button
                  className="me-2  btn-no"
                  onClick={() => {
                    setPopups(false);
                  }}
                >
                  {/* No */}
                  {t("No")}
                </button>
                <button
                  className="ms-2  btn-yes"
                  onClick={() => {
                    history.goBack();
                  }}
                >
                  {/* Yes */}
                  {t("Yes")}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export const QuickBookNotification = (qbResponse) => {
  toast.dismiss();
  toast(<QuickBookNotificationMessage qbResponse={qbResponse} />, {
    icon: () => <img src={LogoSmall} width={35} />,
    className: "app-notification qbtoastError",
    data: {
      sound: new Audio(floatingSound),
    },
    autoClose: false,
  });
};

const QuickBookNotificationMessage = ({ qbResponse }) => {
  if (qbResponse && qbResponse?.status == true) {
    return <div>Data Sync to QuickBook Successfully</div>;
  } else {
    return (
      <div className="qb-err">
        {qbResponse.data &&
          qbResponse.data.map((err, i) => {
            return (
              <label className="qb-err-label">
                {err}
                <br />
                <br />
              </label>
            );
          })}
      </div>
    );
  }
};

export default Profilepage;
